// @ts-nocheck
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import * as React from 'react';
import successAlertIcon from '../assets/images/icons/successAlert.svg'
import errorAlertIcon from '../assets/images/icons/errorAlert.svg'
import warningAlertIcon from '../assets/images/icons/warningAlert.svg'
import { useEffect } from 'react';
import { IconButton, Typography } from '@mui/material';
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={20} ref={ref} variant="filled" {...props} />;
});

export default function CustomizedSnackbars(props) {
  const { setMsgData, msgData } = props;
  const [alertStyles, setAlertStyles] = React.useState({});
  let {
    open = false,
    autoHideDuration = 4000,
    severity = 'success',
    message = 'This is a test message',
  } = msgData;
  const onClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setMsgData({ ...msgData, open: false });
  };
  useEffect(() => {
    fetchAlertIconAndStyle(severity)
  }, [severity])
  const fetchAlertIconAndStyle = (severity) => {
    const styleObj = {};
    switch (severity) {
      case 'success':
        styleObj.icon = successAlertIcon;
        styleObj.style = {};
        styleObj.background = 'linear-gradient(120deg,rgba(0, 237, 81, 0.12) 0%, rgba(255, 255, 255, 1) 40%)';
        break;
      case 'error':
        styleObj.icon = errorAlertIcon;
        styleObj.style = {};
        styleObj.background = 'linear-gradient(120deg,rgba(240, 66, 72, 0.13) 0%, rgba(255, 255, 255, 1) 40%)';
        break;
      case 'warning':
        styleObj.icon = warningAlertIcon;
        styleObj.style = {};
        styleObj.background = 'linear-gradient(120deg,rgba(255, 212, 38, 0.11) 0%, rgba(255, 255, 255, 1) 40%)';
        break;
      default:
        styleObj.icon = successAlertIcon;
        styleObj.style = {};
        styleObj.background = 'linear-gradient(120deg,rgba(0, 237, 81, 0.12) 0%, rgba(255, 255, 255, 1) 40%)';
        break;
    }
    setAlertStyles(styleObj)

  }

  return (
    <Stack spacing={6} sx={{ width: '200%' }}>
      <Snackbar open={open} anchorOrigin={{ vertical: 'top', horizontal: "center", boxShadow: "none" }} autoHideDuration={autoHideDuration} onClose={onClose}>
        <Alert action={<CloseIconComponent onClick={onClose} />} icon={<IconButton
          aria-label="close"
          color="inherit"
          size="small"
          disableRipple
        ><AlertIconComponent icon={alertStyles.icon} style={alertStyles.style} /></IconButton>} onClose={onClose} severity={severity} sx={{ "& .MuiAlert-action": { display: 'flex', justifyItems: 'center', alignItems: 'center', padding: 0 }, "& .MuiAlert-message": { display: 'flex', alignItems: 'center' }, color: 'black', width: '343px', Padding: '12px 16px', borderRadius: '8px', boxShadow: '0 0 24px 0 rgba(0, 0, 0, 0.10)', background: alertStyles.background }}>
          <Typography fontSize={16} fontWeight={600} >
            {message}
          </Typography>
        </Alert>
      </Snackbar>
    </Stack>
  );
}


const AlertIconComponent = ({ icon, style, onClick }) => {
  return (
    <img src={icon} alt="alert icon" style={style} onClick={onClick} />
  )
}

const CloseIconComponent = ({ onClick }) => {
  return (
    <IconButton
      aria-label="close"
      color="inherit"
      size="small"
      onClick={onClick}
      disableRipple
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path d="M18 18.5L12 12.5M12 12.5L6 6.5M12 12.5L18 6.5M12 12.5L6 18.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </IconButton>
  );
};
